import { render } from "./RightClick.vue?vue&type=template&id=dc9a3152&scoped=true"
import script from "./RightClick.vue?vue&type=script&lang=js"
export * from "./RightClick.vue?vue&type=script&lang=js"

import "./RightClick.vue?vue&type=style&index=0&id=dc9a3152&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc9a3152"]])

export default __exports__